import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './components/layout/Header';
import HomePage from './pages/home/HomePage';
import ProductsPage from './pages/products/ProductsPage';
import AboutPage from './pages/about/AboutPage';
import HelpCenter from './pages/help/HelpCenter';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import AccountRedirect from './pages/account/AccountRedirect';
import ContactPage from './pages/contact/ContactPage';
import AiPage from './pages/ai/AiPage';
import NewsPage from './pages/news/NewsPage';
import { ThemeProvider } from './contexts/ThemeContext';
import { AnimationProvider } from './contexts/AnimationContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Loader from './components/common/Loader';
import PageTransition from './components/common/PageTransition';
import { useAnimation } from './contexts/AnimationContext';
import Footer from './components/layout/Footer';

// 内部路由组件，使用动画上下文
const AppRoutes: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { isPageLoading } = useAnimation();
  
  return (
    <>
      {/* 页面加载动画 */}
      <Loader isLoading={isPageLoading} />
      
      {/* 背景效果 */}
      <div className="stars-bg"></div>
      <div className="center-glow"></div>
      <div className="digital-rain"></div>
      
      {/* 页面内容 */}
      <div className="app" style={{ visibility: isPageLoading ? 'hidden' : 'visible' }}>
        <Header />
        <main className="main-content">
          <PageTransition location={location.pathname}>
            <Routes location={location}>
              <Route path="/" element={<HomePage />} />
              {/* 产品相关路由 */}
              <Route path="/products/*" element={<ProductsPage />} />
              {/* AI算法挖矿路由 */}
              <Route path="/ai/*" element={<AiPage />} />
              {/* 关于平台路由 */}
              <Route path="/about/*" element={<AboutPage />} />
              {/* 联系我们路由 */}
              <Route path="/contact/*" element={<ContactPage />} />
              {/* 帮助中心路由 */}
              <Route path="/help/*" element={<HelpCenter />} />
              {/* 法律条款相关路由 */}
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              {/* 账户重定向路由 */}
              <Route path="/account" element={<AccountRedirect />} />
              <Route path="/login" element={<AccountRedirect />} />
              <Route path="/register" element={<AccountRedirect />} />
              {/* 博客/公告路由 */}
              <Route path="/news/*" element={<NewsPage />} />
              <Route path="/blog/*" element={<NewsPage />} />
              {/* 404页面 */}
              <Route path="*" element={<div>{t('common.pageNotFound')}</div>} />
            </Routes>
          </PageTransition>
        </main>
        <Footer />
      </div>
    </>
  );
};

/**
 * 应用程序根组件
 * 提供主题上下文、动画上下文、语言上下文并管理全局路由
 */
const App: React.FC = () => {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AnimationProvider>
          <AppRoutes />
        </AnimationProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App; 